<template>
  <div class="w-full select-none" ref="container">
    <div
      class="w-fit h-[30px] font-secondary text-gray-800 flex items-center whitespace-nowrap"
      ref="component"
    >
      <div v-if="hiddenLocations.length" class="flex items-center mr-1">
        <Float.Base anchor="left">
          <Float.Trigger>
            <div
              class="cursor-pointer mr-1 hover:bg-gray-800/6 rounded-sm flex items-center justify-center"
              :style="iconStyles"
            >
              <Icon
                name="ThreeDots"
                :size="props.iconSize"
                class="fill-gray-800 stroke-gray-800"
              />
            </div>
          </Float.Trigger>
          <Float.Component>
            <MenuList class="w-fit! max-w-[280px]">
              <MenuListItem
                v-for="(location, index) in hiddenLocations"
                :key="index"
                @click="handleClick(index)"
              >
                {{ location }}
              </MenuListItem>
            </MenuList>
          </Float.Component>
        </Float.Base>
        <div class="no-select">/</div>
      </div>
      <template v-for="(location, index) in visibleLocations" :key="index">
        <div
          :class="`cursor-pointer last:cursor-default hover:underline last:hover:no-underline opacity-60 last:opacity-100 ${props.activeLocationClass}`"
          @click="handleClick(index + hiddenLocations.length)"
        >
          {{ location }}
        </div>
        <div v-if="shouldShowSeparator(index)" class="mx-1 opacity-60">/</div>
      </template>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useBreadcrumb } from '@/shared/composables/useBreadcrumb'
import { computed, ref } from 'vue'
import { Icon, Float } from '@dacr/ui'
import { MenuList, MenuListItem } from '@/shared/components/Menu'

const props = withDefaults(
  defineProps<{
    path: string[]
    iconSize: number
    dropdownPosition?: 'top-left' | 'top-right'
    activeLocationClass?: string
  }>(),
  {
    activeLocationClass: 'last:font-semibold last:font-primary',
  }
)
const emit = defineEmits(['location'])

const container = ref<HTMLDivElement | null>(null)
const component = ref<HTMLDivElement | null>(null)
const { visibleLocations, hiddenLocations } = useBreadcrumb({
  path: props.path,
  containerRef: container,
  componentRef: component,
})

const iconStyles = computed(() => ({
  minWidth: `${props.iconSize + 8}px`,
  maxWidth: `${props.iconSize + 8}px`,
  minHeight: `${props.iconSize + 8}px`,
  maxHeight: `${props.iconSize + 8}px`,
}))

const shouldShowSeparator = (index: number) => {
  return index !== visibleLocations.value.length - 1
}

const handleClick = async (index: number) => {
  if (index === 0) {
    emit('location', props.path.slice(0, 1))
  } else {
    emit('location', props.path.slice(0, index + 1))
  }
}
</script>
